/**
 * 파일 다운로드 트리거 (BIZ-47). 쿠키 세션 인증이라 같은 오리진 GET이면 세션이 자동으로 실린다
 * (dev는 vite 프록시, 프로덕션은 API가 web을 같이 서빙해 동일 오리진). Content-Disposition:attachment
 * 응답이라 페이지 이동 없이 내려받는다.
 */
export function triggerDownload(url: string): void {
  const a = document.createElement('a')
  a.href = url
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

/** 값이 있는 항목만 쿼리스트링으로 만든다. */
export function toQuery(params: Record<string, string | undefined>): string {
  const sp = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value) sp.set(key, value)
  }
  const s = sp.toString()
  return s ? `?${s}` : ''
}
